import React from "react";
import CardGrid from "./CardGrid";
import { getItemTypeColor } from "../utils/colors";
import { ListingWithDetails } from "../types";
import CardSkeleton from "./page-layout/Card/CardSkeleton";
import { Card } from "./page-layout/Card/Card";

interface OfferingMember {
  offeringId: string;
  memberId: string;
  role: string;
}

interface Member {
  id: string;
  name: string;
  imageUrls?: string[];
  type?: string;
  description?: string;
  category?: string;
  locationName?: string;
}

interface OfferingsListProps {
  items: ListingWithDetails[];
  selectedOffering: ListingWithDetails | null;
  onOfferingSelect: (offering: ListingWithDetails | null) => void;
  onOfferingFlyTo?: (offering: ListingWithDetails) => void;
  offeringMembers?: OfferingMember[];
  members?: Record<string, Member>;
  loading?: boolean;
}

export const ListingItemsList: React.FC<OfferingsListProps> = ({
  items,
  selectedOffering,
  onOfferingSelect,
  onOfferingFlyTo,
  offeringMembers = [],
  members = {},
  loading = false,
}) => {
  const getOfferingCreators = (offeringId: string) => {
    const creators = offeringMembers
      .filter((em) => em.offeringId === offeringId && em.role === "creator")
      .map((em) => members[em.memberId])
      .filter((member) => member)
      .map((member) => ({
        id: member.id,
        name: member.name,
        imageUrl: member.imageUrls?.[0],
        type: member.type,
        description: member.description,
        category: member.category,
        location: member.locationName,
      }));

    return creators;
  };
  if (loading) {
    return (
      <CardGrid emptyMessage="" emptySubtext="">
        {Array.from({ length: 6 }).map((_, index) => (
          <CardSkeleton key={`skeleton-${index}`} />
        ))}
      </CardGrid>
    );
  }

  return (
    <CardGrid
      emptyMessage="No dream offerings found."
      emptySubtext="Check back soon for upcoming offerings!"
    >
      {items.map((item) => (
        <Card
          key={item.id}
          listingId={item.id}
          listingUserId={item.userId || ""}
          imageUrls={[item.imageUrl || item.coverImgUrl || ""]}
          title={item.name}
          type={item.subType}
          subTypeLabel={item.subType || "other"}
          typeColor={getItemTypeColor(item.itemType)}
          onClick={() => {
            onOfferingSelect(item);
            onOfferingFlyTo?.(item);
          }}
          selected={selectedOffering?.id === item.id}
          creators={getOfferingCreators(item.id)}
        >
          <div className="card-location">
            📍{" "}
            {item.locationName === "Online" ? "Online only" : item.locationName}
          </div>
          {/* <div className="card-extra-item">
            📅{" "}
            {offering.dateLabel ||
              (offering.startDate
                ? new Date(offering.startDate).toLocaleDateString()
                : "TBA")}
          </div> */}
          <div className="card-description">{item.description}</div>
        </Card>
      ))}
    </CardGrid>
  );
};
